import Application from './application';
import { trackEvent } from './utilities/index';

let Results = function (params) {
  // console.log('Results initalizing ' + params);

  /**
   *
   */
  let self = this;
  let ResultsElement = document.getElementById( 'results' );
  let background = ResultsElement.querySelector('.bg-image' );
  let primaryTitle = ResultsElement.querySelector('h2.primary' );
  let alternativeTitle = ResultsElement.querySelector('h2.alternative' );
  let logo = ResultsElement.querySelector('.iron-logo' );
  let description = ResultsElement.querySelector('.iron-description' );
  let learnMore = ResultsElement.querySelector('.more-content' );
  let moreButton = ResultsElement.querySelector('.more-button' );
  let fittingButton = ResultsElement.querySelector('.fitting-button' );
  let clubImage = ResultsElement.querySelector('.selected-iron' );
  let homeButton = ResultsElement.querySelector('.home-button');
  let previousButton = ResultsElement.querySelector('.previous-button');
  let showAlternativeButton = ResultsElement.querySelector('.show-alternative-results-button');
  let showPrimaryButton = ResultsElement.querySelector('.show-primary-results-button');
  let timeline;
  let nextPage = "primary";
  let ironId = "";

  this.open = function() {
    // console.log('Results.open');
    // todo: set dynamic content first?
    this.setResults();
    moreButton = ResultsElement.querySelector('.more-button-' + ironId );
    // TweenLite.set( ResultsElement, {opacity: 1});
    TweenLite.set( [background, primaryTitle, alternativeTitle, logo, description, learnMore, clubImage, homeButton, previousButton], {opacity: 0});
    ResultsElement.style.display = 'block';
    timeline = new TimelineLite({onComplete: this.openComplete, onCompleteScope: this});
    timeline.to(background, Application.tweenLength, {opacity: 1});
    timeline.to([primaryTitle, alternativeTitle, logo, description], Application.tweenLength, {opacity: 1}, Application.tweenStagger);
    timeline.to(clubImage, Application.tweenLength, {opacity: 1}, Application.tweenStagger);
    timeline.to(learnMore, Application.tweenLength, {opacity: 1}, Application.tweenStagger);
    timeline.to([homeButton, previousButton], Application.tweenLength, {opacity: 1}, Application.tweenStagger);
    timeline.play();
  };

  this.setResults = function() {
    // ironId = window.ironSelector.calculateResults();
    let sortedScores = window.ironSelector.calculateResults();
    if (nextPage === "alternative") {
      ironId = sortedScores[1];
      // toggle buttons
      showPrimaryButton.style.display = 'inline-block';
      showAlternativeButton.style.display = 'none';
      alternativeTitle.style.display = 'block';
      primaryTitle.style.display = 'none';
    } else {
      ironId = sortedScores[0];
      // toggle buttons
      showPrimaryButton.style.display = 'none';
      showAlternativeButton.style.display = 'inline-block';
      alternativeTitle.style.display = 'none';
      primaryTitle.style.display = 'block';
    }
    console.log('selected iron id is: ' + ironId);
    ResultsElement.classList.add('show-' + ironId);
    nextPage = "";

    // track here or in the application?
    trackEvent('Recommendation', 'Primary', sortedScores[0]);
    trackEvent('Recommendation', 'Alternative', sortedScores[1]);
  };

  this.openComplete = function () {
    // todo: initialize controls
    previousButton.addEventListener('click', this.previousClicked);
    homeButton.addEventListener('click', this.homeClicked);
    showAlternativeButton.addEventListener('click', this.alternativeClicked);
    showPrimaryButton.addEventListener('click', this.primaryClicked);
    // tracking listners
    moreButton.addEventListener('click', this.moreClicked);
    fittingButton.addEventListener('click', this.fittingClicked);

  };

  this.moreClicked = function(event) {
    trackEvent('navigation', 'Results', 'Product Details');
  };

  this.fittingClicked = function(event) {
    trackEvent('navigation', 'Results', 'Find A Fitting Location');
  };

  this.homeClicked = function(event) {
    nextPage = "home";
    self.close();
    trackEvent('navigation', 'Home');
  };

  this.previousClicked = function(event) {
    nextPage = "question";
    self.close();
    trackEvent('navigation', 'Previous');
  };

  this.alternativeClicked = function(event) {
    nextPage = "alternative";
    self.close();
    trackEvent('navigation', 'Results', 'See Alternative Results');
  };

  this.primaryClicked = function(event) {
    nextPage = "primary";
    self.close();
    trackEvent('navigation', 'Results', 'See Primary Results');
  };

  this.disableControls = function () {
    // console.log('disable controls ' + homeButton);
    previousButton.removeEventListener('click', this.previousClicked);
    homeButton.removeEventListener('click', this.homeClicked);
    showAlternativeButton.removeEventListener('click', this.alternativeClicked);
    showPrimaryButton.removeEventListener('click', this.primaryClicked);
    moreButton.removeEventListener('click', this.moreClicked);
    fittingButton.removeEventListener('click', this.fittingClicked);
  };

  this.close = function () {
    console.log('close ' + nextPage);
    this.disableControls();
    timeline.kill();
    timeline = new TimelineLite({onComplete: closeComplete});
    timeline.to([homeButton, previousButton], Application.tweenLength, {opacity: 0});
    timeline.to(learnMore, Application.tweenLength, {opacity: 0}, Application.tweenStagger);
    timeline.to(clubImage, Application.tweenLength, {opacity: 0}, Application.tweenStagger);
    timeline.to([primaryTitle, alternativeTitle, logo, description], Application.tweenLength, {opacity: 0}, Application.tweenStagger);
    timeline.to(background, Application.tweenLength, {opacity: 0}, Application.tweenStagger);
    timeline.timeScale(1.5);
    timeline.play();
  };

  function closeComplete() {
    // console.log('closeComplete ' + nextPage);
    timeline.kill();
    timeline = null;
    ResultsElement.style.display = 'none';
    ResultsElement.classList.remove('show-' + ironId);
    if (nextPage === "home") {
      // console.log('reset');
      nextPage = "primary";
      window.ironSelector.reset();
    } else if (nextPage === "question") {
      // console.log('previous');
      nextPage = "primary";
      window.ironSelector.questionClosed(-1);
    }else if (nextPage === "primary") {
      console.log('primary');
      self.open();
    }else if (nextPage === "alternative") {
      console.log('alternative');
      self.open();
    }
  }

};

export default Results;

